// extracted by mini-css-extract-plugin
export default {"resetForm":"resetpassword_resetForm__VQW61","link":"resetpassword_link__sa6BP"};